export interface LegacyWorkroomItem {
  id: string
  typeId: string
  typeName: string
  name: string
  hidden: boolean
}

export const legacyWorkroomOffices = [
  { id: '1', name: 'Mock 본점' },
  { id: '2', name: 'Mock 2호점' },
  { id: '3', name: 'Mock 교육점' },
]

export const legacyWorkroomTypes = [{ id: '1', name: 'Mock 작업실' }]

export const legacyWorkrooms: LegacyWorkroomItem[] = [
  ...Array.from({ length: 11 }, (_, index) => ({ id: `WR-${101 + index}`, typeId: '1', typeName: 'Mock 작업실', name: `Mock 작업실 ${index + 1}`, hidden: false })),
  ...Array.from({ length: 4 }, (_, index) => ({ id: `WR-${201 + index}`, typeId: '1', typeName: 'Mock 작업실', name: `Mock 미표시 작업실 ${index + 1}`, hidden: true })),
]
